var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBin2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-bin-2__Action Type=Delete-bin2, State=Enabled, Size=24",
    className: "delete-bin-2__Action delete-bin-2__Type=Delete-bin2, delete-bin-2__State=Enabled, delete-bin-2__Size=24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete-bin-2__Vector 3721 (Stroke)",
    fill: "#454F5B",
    d: "M17.342 7.771H6.804v11.3c0 .69.56 1.25 1.25 1.25h8.038c.69 0 1.25-.56 1.25-1.25V7.77ZM14.69 4.93c0-.69-.56-1.25-1.25-1.25h-2.742c-.69 0-1.25.56-1.25 1.25v1.34h5.242V4.93Zm1.5 1.341h4.438a.75.75 0 0 1 0 1.5h-1.786v11.3a2.75 2.75 0 0 1-2.75 2.75H8.054a2.75 2.75 0 0 1-2.75-2.75V7.77H3.372a.75.75 0 1 1 0-1.5h4.576V4.93a2.75 2.75 0 0 1 2.75-2.75h2.742a2.75 2.75 0 0 1 2.75 2.75v1.34Z",
    className: "delete-bin-2__Vector delete-bin-2__3721 delete-bin-2__(Stroke)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBin2);
export default __webpack_public_path__ + "static/media/delete-bin2.c0b672149c7af0bedb1a3cba77d0fbbd.svg";
export { ForwardRef as ReactComponent };